import { Gender } from './gender.interface';
import { GenderService } from './gender.service';
const service = new GenderService();

export interface GenderState {
   genders: Array<Gender>;
}

const state: GenderState = {
   genders: [],
};

const getters = {
   genders(state: any) {
      return state.genders;
   },
};

const mutations = {
   SET_GENDERS(state: any, genders: Array<Gender>) {
      state.genders = genders;
   },
};

const actions = {
   async getGenders(context: any) {
      return await service.getGenders().then((response) => {
         context.commit('SET_GENDERS', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
